import { BaseService } from "./baseService";
import { AllergyDto, allergyFormData } from "../types/allergy"; // Βεβαιώσου ότι το path είναι σωστό

class AllergyService extends BaseService<AllergyDto, typeof allergyFormData> {
  constructor() {
    super("/Allergy");
  }
}
export const allergyService = new AllergyService();
